import { IUpsertProductPayload, ProductModel } from '@boxx/store-core';
import { createAction, props } from '@ngrx/store';

export enum StoreProductsActionTypes {
  loadProductsBegin = '[STORE] Load Products Begin',
  loadProductsSuccess = '[STORE] Load Products Success',
  loadProductsFail = '[STORE] Load Products Fail',

  loadProductByIdBegin = '[STORE] Load Product By Id Begin',
  loadProductByIdSuccess = '[STORE] Load Product By Id Success',
  loadProductByIdFail = '[STORE] Load Product By Id Fail',

  createProductBegin = '[STORE] Create Product Begin',
  createProductSuccess = '[STORE] Create Product Success',
  createProductFail = '[STORE] Create Product Fail',

  updateProductBegin = '[STORE] Update Product Begin',
  updateProductSuccess = '[STORE] Update Product Success',
  updateProductFail = '[STORE] Update Product Fail',

  deleteProductBegin = '[STORE] Delete Product Begin',
  deleteProductSuccess = '[STORE] Delete Product Success',
  deleteProductFail = '[STORE] Delete Product Fail',

  loadSingleProductBegin = '[STORE] Load Single Product Begin',
  loadSingleProductSuccess = '[STORE] Load Single Product Success',
  loadSingleProductFail = '[STORE] Load Single Product Fail',

  loadUpdatedProductBegin = '[STORE] Load Updated Product Begin',
  loadUpdatedProductSuccess = '[STORE] Load Updated Product Success',
  loadUpdatedProductFail = '[STORE] Load Updated Product Fail',

  deleteImageProductBegin = '[STORE] Delete Image Product Begin',
  deleteImageProductSuccess = '[STORE] Delete Image Product Success',
  deleteImageProductFail = '[STORE] Delete Image Product Fail',

  clearProductsSuccessErrorData = '[STORE] Clear Products Success/Error Data',
}

export const loadProductsBeginAction = createAction(
  StoreProductsActionTypes.loadProductsBegin
);

export const loadProductsSuccessAction = createAction(
  StoreProductsActionTypes.loadProductsSuccess,
  props<{ payload: ProductModel[] }>()
);

export const loadProductsFailAction = createAction(
  StoreProductsActionTypes.loadProductsFail,
  props<{ errors: any }>()
);

export const loadProductByIdBeginAction = createAction(
  StoreProductsActionTypes.loadProductByIdBegin,
  props<{ id: number }>()
);

export const loadProductByIdSuccessAction = createAction(
  StoreProductsActionTypes.loadProductByIdSuccess,
  props<{ payload: ProductModel }>()
);

export const loadProductByIdFailAction = createAction(
  StoreProductsActionTypes.loadProductByIdFail,
  props<{ errors: any }>()
);

export const createProductBeginAction = createAction(
  StoreProductsActionTypes.createProductBegin,
  props<{ payload: IUpsertProductPayload }>()
);

export const createProductSuccessAction = createAction(
  StoreProductsActionTypes.createProductSuccess,
  props<{ payload: any }>()
);

export const createProductFailAction = createAction(
  StoreProductsActionTypes.createProductFail,
  props<{ errors: any }>()
);

export const updateProductBeginAction = createAction(
  StoreProductsActionTypes.updateProductBegin,
  props<{ payload: IUpsertProductPayload }>()
);

export const updateProductSuccessAction = createAction(
  StoreProductsActionTypes.updateProductSuccess,
  props<{ payload: ProductModel }>()
);

export const updateProductFailAction = createAction(
  StoreProductsActionTypes.updateProductFail,
  props<{ errors: any }>()
);

export const deleteProductBeginAction = createAction(
  StoreProductsActionTypes.deleteProductBegin,
  props<{ id: number }>()
);

export const deleteProductSuccessAction = createAction(
  StoreProductsActionTypes.deleteProductSuccess,
  props<{ payload: ProductModel[] }>()
);

export const deleteProductFailAction = createAction(
  StoreProductsActionTypes.deleteProductFail,
  props<{ errors: any }>()
);

export const clearProductsSuccessErrorDataAction = createAction(
  StoreProductsActionTypes.clearProductsSuccessErrorData
);

export const loadSingleProductBeginAction = createAction(
  StoreProductsActionTypes.loadSingleProductBegin,
  props<{ id: number }>()
);

export const loadSingleProductSuccessAction = createAction(
  StoreProductsActionTypes.loadSingleProductSuccess,
  props<{ payload: ProductModel[] }>()
);

export const loadSingleProductFailAction = createAction(
  StoreProductsActionTypes.loadSingleProductFail,
  props<{ errors: any }>()
);

export const loadUpdatedProductBeginAction = createAction(
  StoreProductsActionTypes.loadUpdatedProductBegin,
  props<{ id: number }>()
);

export const loadUpdatedProductSuccessAction = createAction(
  StoreProductsActionTypes.loadUpdatedProductSuccess,
  props<{ payload: ProductModel }>()
);

export const loadUpdatedProductFailAction = createAction(
  StoreProductsActionTypes.loadUpdatedProductFail,
  props<{ errors: any }>()
);

export const deleteImageProductBeginAction = createAction(
  StoreProductsActionTypes.deleteImageProductBegin,
  props<{ payload: any }>()
);

export const deleteImageProductSuccessAction = createAction(
  StoreProductsActionTypes.deleteImageProductSuccess,
  props<{ payload: any }>()
);

export const deleteImageProductFailAction = createAction(
  StoreProductsActionTypes.deleteImageProductFail,
  props<{ errors: any }>()
);

